export const HE = {
    navigation: {
        recents: 'אחרונות',
        dialpad: 'חייגן',
        contacts: 'אנשי קשר',
        settings: 'הגדרות'
    },
    account: 'החשבון שלי',
    call_preferences: 'העדפויות שיחה',
    conference: 'ועידה',
    transfer_call: 'העברת שיחה',
    add_call: 'הוסף שיחה',
    help: 'עזרה',
    about: 'אודות',
    sound_and_devices: 'קול והתקנים',
    logout: 'התנתק',
    search_contact: 'חפש איש קשר',
    connectionstate: {
        connecting: 'מתחבר...',
        registering: 'נרשם...',
        available: 'זמין',
        unavailable: 'לא זמין',
        disconnected: 'מנותק',
        connected: 'מחובר'
    },
    no_results: 'אין תוצאות',
    unassigned: 'לא משוייך',
    call_now: 'חייג',
    transfer_now: 'העבר עכשיו',
    confirm_transfer: 'האם אתה רוצה להעביר את השיחה ל',
    call_status: {
        finished: 'הסתיימה',
        trying: 'מנסה...',
        incoming: 'נכנסת...',
        calling: 'מחייג...',
        hold: 'החזק'
    },
    hold: 'החזק',
    mute: 'השתק',
    confirm: 'אישור',
    transfer: 'העבר',
    merge: 'מזג',
    add: 'הוספה',
    keypad: 'חייגן',
    swap: 'החלף',
    lead: 'ליד',
    disable_recording: 'עצור הקלטה',
    enable_recording: 'התחל הקלטה',
    transfer_to: 'העברת שיחה ל',
    add_to: 'הוסף שיחה חדשה ל',
    hide: 'הסתר',
    talk_first: 'העברה חמה',
    extensions_domain: 'שלוחה ודומיין',
    account_info: 'מידע אישי',
    change_password: 'שנה סיסמא',
    update: 'עדכון',
    old_pass_ph: 'הכנס סיסמא ישנה',
    new_pass_ph: 'הכנס סיסמא חדשה',
    confirm_pass_ph: 'אמת סיסמא חדשה',
    sound_notifications: 'התראות קול',
    ringtone: 'צלצול',
    speakers: 'שמע',
    output: 'פלט קול',
    ringing_device: 'פלט צלצול',
    microphone: 'מיקרופון',
    default: 'ברירת מחדל',
    default_device: 'התקן ברירת מחדל',
    keyboard_shortcuts: {
        enter_pickup: 'לחץ ENTER כדי לענות',
        esc_decline: 'לחץ ESC כדי לדחות שיחה',
        esc_hangup: 'לחץ ESC כדי לנתק שיחה',
        title: 'קיצורי מקלדת'
    },
    help_items: {
        chat: 'צור קשר',
        report: 'דווח על תקלה'
    },
    email: 'אימייל',
    password: 'סיסמה',
    login: 'התחבר',
    forgot_password: 'שכחתי סיסמא?',
    cancel: 'ביטול',
    reset_password: 'אפס סיסמא',
    enter_name: 'הכנס שם',
    info: 'מידע',
    private: 'אישי',
    int_connection_lost: 'אבד החיבור לאינטרנט!',
    int_connnection_lost_desc: 'נראה שהמחשב שלך במצב לא מקוון. נמשיך לנסות להתחבר מחדש.',
    no_contacts: 'אין לך עדיין אנשי קשר.',
    mic_requirted: 'נדרשת גישה למיקרופון',
    mic_requirted_desc: 'חבר את המיקרופון ו(או) הענק הרשאה לדפדפן להשתמש בו!',
    restart_app: 'הפעל מחדש את האפליקציה',
    password_must: 'הסיסמא חייבת לכלול',
    password_recovery_strength: 'לפחות מספר, אות ותו מיוחד',
    no_recents: 'אין לך שיחות אחרונות.',
    no_recents_msg: 'בצע שיחה ראשונה!',
    listening: 'אתה מקשיב',
    now: 'עכשיו',
    ws_disconnection: 'ניתוק רשת הטלפון, נמשיך לנסות להתחבר מחדש',
    ws_reconnection_failed:
        'האפליקציה לא הצליחה להתחבר מחדש לשרת, תקן את חיבור האינטרנט שלך והפעל מחדש את האפליקציה בבקשה',
    language: 'שפה',
    select: 'בחר',
    nothing_selected: 'שום דבר לא נבחר',
    numberValidationError: 'המספר לא חוקי!',
    countryNumberValidationError: 'מספר המדינה שצוין אינו חוקי!',
    sessionExpired: 'הפעולה לא זמינה',
    auto_reject: 'דחייה אוטומטית במהלך שיחה',
    auto_reject_tooltip: 'דחה שיחות נכנסות באופן אוטומטי בזמן שאתה עסוק בשיחה אחרת',
    general: 'כללי',
    field_required: 'שדה נדרש',
    password_validation: {
        lowercase: 'הסיסמה חייבת להכיל לפחות אות קטנה אחת',
        uppercase: 'הסיסמה חייבת להכיל לפחות אות אחת גדולה',
        digit: 'הסיסמה חייבת להכיל לפחות ספרה אחת',
        length: 'הסיסמה חייבת להיות באורך 8 תווים לפחות',
        confirmation: 'סיסמא לא תואמת'
    },
    email_incorrect: 'כתובת האימייל שסופקה אינה נכונה',
    version: 'גִרְסָה',
    auto_pickup: 'מענה אוטומטי לקליק טו קול',
    auto_pickup_tooltip: 'מפעיל את השיחה באופן אוטומטי כאשר מתבצעת Click2Call על ידי המשתמש',
    notification: {
        call_to: 'מתקשר אל',
        incoming_call: 'שיחה נכנסת',
        tab_focus: 'חייגן פעיל כאן',
        tab_focus_desc: 'לחצו כאן לפתיחת החייגן '
    },
    multipleTabsTitle: 'אסור להשתמש במספר חלונות!',
    multipleTabsDescription: 'נראה שהאפליקציה כבר פתוחה בכרטיסייה/חלון אחר בדפדפן',
    focusActive: 'חייגן פעיל',
    forceActive: 'כוח הפעלה',
    inbound_call: 'שיחה נכנסת',
    codecs: 'קודקים',
    codecsDescription:
        'השתמש בתיבת הסימון כדי להפעיל/לבטל רכיבי Codec. גרור ושחרר פריטים כדי לשנות את עדיפות ה-codec מופעלת (מיקום גבוה יותר - עדיפות גבוהה יותר)',
    codecName: 'שֵׁם',
    codecRate: 'תדר / ערוצים',
    hertz: 'הרץ',
    open_lead_at: 'מוביל פתוח ב-',
    caller_insights: 'Caller Insights',
    company: 'חברה',
    last_modified: 'שינויים אחרונים',
    owner: 'בעלים',
    integration: 'אינטגרציה',
    installed_integration: 'אינטגרציה מעודכנת ופעילה',
    preferences: 'העדיפויות',
    search_lead_number: 'חיפוש ליד לפי מספר טלפון',
    no_integration: 'אין אינטגרציה פעילה',
    search_lead_tooltip: 'חפש והצג מידע מפורט של לידים בעת ביצוע/קבלה של שיחות',
    records_found: 'נמצאו רשומות',
    no_records_found: 'לא נמצאו רשומות',
    create: 'לִיצוֹר',
    search_kavkomcrm_only: 'חיפוש לידים דרך Kavkom בלבד ',
    search_kavkomcrm_tooltip: 'חיפוש לידים לפי מערכת לניהול לידים שמחוברת לאינטגרציה',
    kavkom_crm: 'Kavkom CRM',
    manage_conference: 'לנהל',
}
